import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Overview from './Overview';
import PrimaryParameters from './PrimaryParameters';
import Results from './Results';


class Calculator extends Component {

    getTitle() {
        return <h3>Award Points Value Calculator</h3>;
    }

    render() {
        return (
            <Row>
                <Col md={6} className="pa-sm">
                    <Overview />
                    <PrimaryParameters />
                </Col>
                <Col md={6} className="pa-sm">
                    <Results />
                </Col>
            </Row>
        );
    }
}

export default Calculator;
